import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewEncapsulation,
  booleanAttribute,
  inject,
} from '@angular/core';
import { AccordionComponent } from './accordion.component';

let nextId = 0;

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-expansion-panel',
    '[class.app-expanded]': 'expanded',
  },
})
export class ExpansionPanelComponent implements OnDestroy {
  readonly contentId = `app-expansion-content-${nextId}`;
  readonly headerId = `app-expansion-header-${nextId++}`;

  @Input({ transform: booleanAttribute }) expanded = false;
  @Output() expandedChange = new EventEmitter<boolean>();

  private readonly accordion = inject(AccordionComponent, { optional: true });

  constructor() {
    this.accordion?.register(this);
  }

  ngOnDestroy(): void {
    this.accordion?.unregister(this);
  }

  toggle(): void {
    this.setExpanded(!this.expanded);
    if (this.expanded) {
      this.accordion?.onPanelOpened(this);
    }
  }

  setExpanded(value: boolean): void {
    if (this.expanded === value) {
      return;
    }
    this.expanded = value;
    this.expandedChange.emit(value);
  }
}
